import React from "react";
import { BrowserRouter } from "react-router-dom";
import RoutesView from "./routes";
import { AuthProvider } from "./providers/AuthProvider";
import { ApiProvider } from "./providers/ApiProvider";

const App = () => {
  return (
    <BrowserRouter>
      <ApiProvider>
        <AuthProvider>
          <RoutesView />
        </AuthProvider>
      </ApiProvider>
    </BrowserRouter>
  );
};

export default App;
